export default "__VITE_ASSET__Fcyzvojv__"